module.exports = __webpack_public_path__ + "static/media/guide.8796ca2e.jpg";